import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  text?: string
  className?: any
  textClassName?: any
}

const ChipComponent = ({ text, className, textClassName }: Props) => (
  <div css={[tw`px-2 py-0.5 rounded-[10px] bg-[#EDEDED]`, className]}>
    <Typography variant="subtitle2" css={textClassName}>
      {text}
    </Typography>
  </div>
)

export const Chip = memo(ChipComponent)
